import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { titleSmall } from 'styles-js/mixins/typography';
import Button from 'src/components/buttons/button';
type Props = {
  options: {
    value: string;
    text: string;
  }[];
  selected: string;
  onFilterClick: (value: string) => void;
};
export default function PostFilterInline({
  options,
  selected,
  onFilterClick
}: Props): JSX.Element {
  return <Container data-sentry-element="Container" data-sentry-component="PostFilterInline" data-sentry-source-file="postFilterInline.tsx">
      {options.map(({
      value,
      text
    }) => <Filter key={value}>
          <RoundedButton dataTestId={selected === value ? 'filter-selected' : ''} icon={value === 'restricted' ? 'cog' : undefined} iconPosition="right" selected={selected === value} text={i18n.t(text)} type="none" onClick={() => onFilterClick(value)} />
        </Filter>)}
    </Container>;
}
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const Filter = styled.div`
  display: flex;
`;
const RoundedButton = styled(Button)<{
  selected: boolean;
}>`
  ${titleSmall};
  padding: 6px 15px;
  border-radius: 20px;
  background-color: ${props => props.selected ? props.theme.colorBlue : props.theme.colorBlueBackground};
  color: ${props => props.selected ? props.theme.colorWhite : props.theme.colorBlack};
  transition: none;

  @media (${props => props.theme.underScreenXxsmall}) {
    padding: 5px 9px;
  }

  &:hover, &:focus, &:active {
    background-color: ${props => props.theme.colorBlue};
    color: ${props => props.theme.colorWhite};
  }
`;